module.exports = __webpack_public_path__ + "static/img/10.82be92b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/10.png
// module id = RAJF
// module chunks = 0